import { render, staticRenderFns } from "./Reflesh.vue?vue&type=template&id=4b810602&scoped=true&"
import script from "./Reflesh.vue?vue&type=script&lang=js&"
export * from "./Reflesh.vue?vue&type=script&lang=js&"
import style0 from "./Reflesh.vue?vue&type=style&index=0&id=4b810602&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b810602",
  null
  
)

export default component.exports